import { createContext, useContext } from 'react';
const ReloadedThemeInfoContext = createContext(undefined);
export const ReloadedThemeInfoProvider = ReloadedThemeInfoContext.Provider;
export const useReloadedThemeInfo = () => {
    const context = useContext(ReloadedThemeInfoContext);
    if (!context) {
        throw new Error('cannot use useReloadedThemeInfo outside a ReloadedProvider');
    }
    return context;
};
//# sourceMappingURL=reloadedThemeInfoContext.js.map